export const SCREEN_SAVER_ANIMATION_TYPE = {
  slider: 'v1',
  lines: 'v2'
};
